export const MARKETPLACE_SHIPPING = 'pdp.marketplace_shipping';
export const MARKETPLACE_SHIPPING_TIME = 'pdp.marketplace_shipping_time';
